export default {
    POPUP_COLOR: "warning",
    POPUP_TIME: 7000,
    FOOTER_HEIGHT: "8dvh",
    ADDITIONAL_SHIFTING_NAME: "Déplacement supplémentaire",
    ADDITIONAL_MAIN_WORK_NAME: "Main d'oeuvre supplémentaire",
}